import navBarHomepage from '../modules/navbar-homepage';

let videoController = () => {
    navBarHomepage.on();
};

export default videoController;
